var _circle, _line, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabourRightsViolations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 615,
    height: 615,
    viewBox: "0 0 615 615",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 307.5,
    cy: 307.5,
    r: 293.5,
    stroke: "#FCFCFC",
    strokeWidth: 28
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 103.636,
    y1: 83.8366,
    x2: 532.04,
    y2: 512.241,
    stroke: "#FCFCFC",
    strokeWidth: 28
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.534 381.979C242.962 408.138 306.32 409.757 383.763 386.644C406.172 379.959 456.949 350.783 484.421 326.488C484.723 323.647 484.977 320.089 485.071 315.547C485.177 314.672 485.32 313.809 485.406 312.93C491.727 250.448 454.21 192.912 396.249 166.868L391.425 144C391.425 144 387.9 144.998 382.728 146.335C338.076 163.589 273.243 212.382 260.462 347.945L226.346 333.958C226.346 333.958 246.495 234.531 295.558 188.292C310.776 173.953 328.742 162.223 346.707 153.179C345.918 153.187 345.19 153.171 344.561 153.105C261.537 144.707 199.091 194.278 175.577 273.724L161.406 337.564L161.153 339.294C164.943 347.451 175.978 366.843 200.534 381.979Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M284.747 414.443C252.602 414.443 220.682 408.306 193.685 391.4C171.512 377.519 159.455 360.678 153.481 349.892C147.283 358.547 138.529 371.602 132.028 384.739C120.85 407.325 121.864 419.852 136.264 426.807C237.834 475.867 271.831 484.866 327.825 457.869C327.825 457.869 425.265 410.473 484.15 362.276C488.648 358.596 496.935 341.257 489.371 337.601C460.252 362.317 409.827 390.995 387.082 397.778C357.153 406.707 320.809 414.443 284.747 414.443Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabourRightsViolations);
export default __webpack_public_path__ + "static/media/labour-rights-violations.fb900dd7f93d2a75b7bede365952883d.svg";
export { ForwardRef as ReactComponent };